module.exports = __webpack_public_path__ + "static/media/22ESCWA15.be4658f4.jpg";